import React from "react";
import { GiSandsOfTime } from "react-icons/gi";

const Loader = () => {
    return (
        <div
            className="
                flex items-center justify-center
                w-full
                min-h-[calc(100vh-80px)]
                overflow-hidden
                bg-[#e9d8ff50]
            "
        >
            <div className="flex flex-col items-center animate-fadeDown">
                <GiSandsOfTime className="text-3xl text-indigo-800 animate-spin-slow" />
                <p className="mt-3 text-base text-gray-700 font-medium">
                    Loading...
                </p>
            </div>
        </div>
    );
};

export default Loader;
